import Carousel from "components/common/Carousel"
import * as S from "./AchievementsOur.style"
import { AchievementsOurCards } from "./AchievementsOurConstants"
import AchievementsOurCard from "./AchievementsOurCards"
import useWindowSize from "hooks/useWindowSize"
import env from "config/envs";

const Cards = AchievementsOurCards.map(({ image, imageFallback, paragraph, title, Backgroundcolor }, index) => (
    <AchievementsOurCard image={image} imageFallback={imageFallback} paragraph={paragraph} title={title} key={index} Backgroundcolor={Backgroundcolor} />
))

const AchievementsOur = () => {
    const { width } = useWindowSize()
    
    return (
        <S.SectionAchievementsOur>
            <S.TitleAchievementsOur>
                Nossas conquistas
            </S.TitleAchievementsOur>
            <S.ParagraphAchievementsOur>
                Somos referência entre grandes empresas de diversos segmentos do mercado brasileiro.
                Confira os destaques de 2024 e, para saber mais sobre tudo o que conquistamos nos
                últimos anos,{" "}
                <a 
                    target="_blank" 
                    href={`${env.HOST_STATIC_CDN}/AreaAberta/Conquistas/conquistas_cnp_seguros_holding_brasil_2024.pdf`} 
                    style={{color: "#002364", fontWeight: 700}} 
                    rel="noreferrer"
                >
                    acesse aqui.
                </a>
            </S.ParagraphAchievementsOur>
            {width < 1025
                ?
                <Carousel children={Cards} noIndicator/>
                :
                <Carousel children={Cards} numberOfSlidersToDisplay={3} spacingToSlider={32} />
            }
        </S.SectionAchievementsOur>
    )
}

export default AchievementsOur